import { useState } from 'react';
import Header from '../../components/Header/Header';
import './RepushWebhook.scss';
import RepushWebhookSheet from '../../components/NewSideSheet/RepushWebhook/RepushWebhookSheet';

const RepushWebhook = () => {
  const [webhookAction, setWebhookAction] = useState<'transfer' | 'p2p'>('transfer');
  const [show, setShow] = useState(false);

  return (
    <>
      <Header name="Repush Webhook" />

      <div className="repush-webhook">
        <div className="repush-webhook__card">
          <div className="options">
            <div
              onClick={() => {
                setWebhookAction('p2p');
                setShow(true);
              }}
              className="option"
            >
              <div className="option-icon">
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M28.3438 8.0625L17 4.28125L5.65625 8.0625V16.8795C5.65625 23.7166 11.5 26.9688 17 29.9359C22.5 26.9688 28.3438 23.7166 28.3438 16.8795V8.0625Z"
                    stroke="#1D4ED8"
                    strokeWidth="2.0625"
                    strokeLinecap="square"
                  />
                </svg>
              </div>
              <div className="option-text">
                <p className="heading">Re-push Webbook</p>
                <p className="description">Session ID</p>
              </div>
              <div className="option-arrow">
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L9 8.99998L1 17" stroke="#64748B" strokeWidth="2" />
                </svg>
              </div>
            </div>
            {/* <div
              onClick={() => {
                setWebhookAction('transfer');
                setShow(true);
              }}
              className="option"
            >
              <div className="option-icon">
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M28.3438 8.0625L17 4.28125L5.65625 8.0625V16.8795C5.65625 23.7166 11.5 26.9688 17 29.9359C22.5 26.9688 28.3438 23.7166 28.3438 16.8795V8.0625Z"
                    stroke="#1D4ED8"
                    strokeWidth="2.0625"
                    strokeLinecap="square"
                  />
                </svg>
              </div>
              <div className="option-text">
                <p className="heading">Re-push Transfer Webhook</p>
                <p className="description">Provider + Reference</p>
              </div>
              <div className="option-arrow">
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L9 8.99998L1 17" stroke="#64748B" strokeWidth="2" />
                </svg>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <RepushWebhookSheet
        show={show}
        id={''}
        which={webhookAction}
        data={{}}
        onClose={() => {
          setShow(false);
        }}
      />
    </>
  );
};

export default RepushWebhook;
